import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { ManagerLayer } from '../components/manger/MangerLayer'

export const MangerPage = () => {
  return (
    <MasterLayout>
      <ManagerLayer />  
    </MasterLayout>
  )
}
